<template>
  <base-card>
    <v-card-text>
      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <h3 class="mb-2">Procesamiento XMLS de comprobantes electrónicos al SRI</h3>
        <h6 class="mb-8">Flujo de procesamiento: Recepción → Autorización → Notificación</h6>

        <v-select
          v-model="selectedCompany"
          :items="filteredCompanies"
          item-text="displayText"
          label="Selecciona una compañía"
          prepend-inner-icon="mdi-domain"
          return-object
          dense
          solo
          @change="fetchToken"
        >
          <template v-slot:prepend-item>
            <v-list-item>
              <v-list-item-content>
                <v-text-field
                  v-model="search"
                  placeholder="Buscar compañía"
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  dense
                  class="mx-4"
                />
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>
        </v-select>
        



        <div v-if="loadingToken"><em>Obteniendo token...</em></div>
      </div>

      <div class="d-flex flex-column align-center justify-center text-center py-6">
        <div v-if="token" class="upload-section">
          <v-file-input
            class="mb-6"
            v-model="files"
            :counter="files.length + ' archivos seleccionados'"
            accept=".xml"
            chips
            outlined
            full-width
            label="Selecciona archivos XML"
            multiple
            show-size
            @change="handleFiles"
          ></v-file-input>

          <v-btn
            :disabled="loading || files.length === 0"
            :loading="loading"
            class="ma-2"
            style="background-color: rgb(204 33 40); color: white !important;"
            @click="uploadFiles"
          >
            Enviar XMLs
          </v-btn>
          <v-btn
            :disabled="loading && files.length === 0"
            class="ma-2"
            color="gray"
            @click="clearFields"
          >
            Limpiar
          </v-btn>
        </div>

        <v-progress-linear
          v-if="loading"
          class="my-4"
          color="primary"
          indeterminate
        ></v-progress-linear>

        <v-alert
          v-if="showAlert"
          :type="alertType"
          dense
          outlined
          border="left"
          colored-border
          class="my-4"
        >
          {{ alertMessage }}
        </v-alert>

        <v-alert
          v-if="copyAlert"
          text
          type="info"
          dense
          class="my-2"
        >
          Clave de acceso copiada al portapapeles
        </v-alert>

        <!-- Modal mejorado -->
        <v-dialog v-model="showModal" max-width="1200px"  persistent>
          <v-card>
            <v-card-title class="headline">
              Resultados del envío
              <v-spacer></v-spacer>
              <v-btn icon @click="showModal = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>

            <v-card-text>
              <v-simple-table dense>
                <thead >
                <tr >
                  <th>Archivo XML</th>
                  <th class="text-center">Consecutivo</th>
                  <th class="text-center">Recepción</th>
                  <th class="text-center">Autorización</th>
                  <th class="text-center">Notificación</th>
                  <th>Mensaje</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="r in resultados" :key="r.consecutivo">
                  <td>{{ r.nameXML }}</td>
                  <td class="text-center">{{ r.consecutivo }}</td>
                  
                  <!-- Estado Recepción -->
                  <td  class="text-center">
                    <v-chip
                      v-if="r.procesamiento"
                      :color="getProcessColor(r.procesamiento.recepcion && r.procesamiento.recepcion.status)"
                      text-color="white"
                      small
                    >
                      {{ getProcessText(r.procesamiento.recepcion && r.procesamiento.recepcion.status) }}
                    </v-chip>
                    <span v-else>-</span>
                  </td>
                  
                  <!-- Estado Autorización -->
                  <td class="text-center">
                    <v-chip
                      v-if="r.procesamiento"
                      :color="getProcessColor(r.procesamiento.autorizacion && r.procesamiento.autorizacion.status)"
                      text-color="white"
                      small
                    >
                      {{ getProcessText(r.procesamiento.autorizacion && r.procesamiento.autorizacion.status) }}
                    </v-chip>
                    <span v-else>-</span>
                  </td>
                  
                  <!-- Estado Notificación -->
                  <td class="text-center">
                    <v-chip
                      v-if="r.procesamiento"
                      :color="getProcessColor(r.procesamiento.notificacion && r.procesamiento.notificacion.status)"
                      text-color="white"
                      small
                    >
                      {{ getProcessText(r.procesamiento.notificacion && r.procesamiento.notificacion.status) }}
                    </v-chip>
                    <span v-else>-</span>
                  </td>
                  
                  <!-- Mensaje más detallado -->
                  <td>
                    <div class="text-caption mt-2">
                      {{ getDetailedMessage(r) }}
                    </div>
                    <div v-if="r.procesamiento && r.procesamiento.autorizacion && r.procesamiento.autorizacion.mensaje_adicional" class="text-caption mt-1">
                      {{ r.procesamiento.autorizacion.mensaje_adicional }}
                    </div>
                    <div v-if="r.procesamiento && r.procesamiento.recepcion && r.procesamiento.recepcion.clave_acceso" class="text-caption mt-1 mb-2">
                      <strong>Clave acceso:</strong> {{ r.procesamiento.recepcion.clave_acceso }}
                      <v-icon
                        @click="copyClaveAcceso(r.procesamiento.recepcion.clave_acceso)"
                        class="ml-2"
                        color="info darken-3"
                        style="cursor: pointer"
                        small
                      >
                        mdi-content-copy
                      </v-icon>
                    </div>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </v-card-text>


          </v-card>
        </v-dialog>

      </div>
    </v-card-text>
  </base-card>
</template>

<script>
import axios from 'axios';
import { environment } from "@/data/environment";

export default {
  data() {
    return {
      companias: [],
      selectedCompany: null,
      token: null,
      search: '',
      files: [],
      resultados: [],
      showModal: false,
      loading: false,
      loadingToken: false,
      showAlert: false,
      alertMessage: '',
      alertType: 'success',
      copyAlert: false
    };
  },
  computed: {
    filteredCompanies() {
      const query = this.search.toLowerCase();
      return this.companias.filter(c => c.displayText.toLowerCase().includes(query));
    }
  },
  mounted() {
    this.fetchCompanies();
  },
  methods: {
    async fetchCompanies() {
      try {
        const res = await axios.get(environment.HIOPOSWEBSERVICES + '/getClientsForXML');
        const data = res.data;
        this.companias = data.Mensaje.map(compania => ({
          ...compania,
          displayText: `${compania.id} - ${compania.name}`
        }));
      } catch (e) {
        this.setAlert('error', 'Error al cargar compañías');
        console.error(e);
      }
    },

    async fetchToken() {
      if (!this.selectedCompany) return;

      this.token = null;
      this.loadingToken = true;

      try {
        const formData = new FormData();
        formData.append('TokenEnterprise', this.selectedCompany.token_enterprise);
        formData.append('TokenPassword', this.selectedCompany.token_password);

        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + '/login',
          formData
        );

        this.token = response.data.token;
      } catch (e) {
        this.setAlert('error', 'Error al obtener token');
        console.error(e);
      } finally {
        this.loadingToken = false;
      }
    },

    handleFiles() {
      const xmlFiles = this.files.filter(file => file.name.endsWith('.xml'));

      if (xmlFiles.length > 15) {
        this.setAlert('warning', 'Solo puedes seleccionar hasta 15 archivos XML.');
        this.files = xmlFiles.slice(0, 15);
      } else {
        this.files = xmlFiles;
      }
    },

    clearFields() {
      this.selectedCompany = null;
      this.search = '';
      this.files = [];
      this.token = null;
      this.resultados = [];
      this.showModal = false;
      this.resetAlert();
    },

    async uploadFiles() {
      this.resetAlert();
      
      if (!this.token) {
        this.setAlert('warning', 'No se ha obtenido el token de autenticación.');
        return;
      }
      
      if (this.files.length === 0) {
        this.setAlert('warning', 'Por favor selecciona al menos un archivo XML.');
        return;
      }

      this.loading = true;
      this.resultados = [];

      try {
        const xmlPayload = await Promise.all(
          this.files.map(async (file) => {
            const content = await file.text();
            return {
              saleXML: content,
              consecutivo: file.name.replace(/\.xml$/i, ''),
              nameXML: file.name.replace(/\.xml$/i, ''),
              compania: this.selectedCompany.id,

            };
          })
        );
        const response = await axios.post(
          environment.HIOPOSWEBSERVICES + '/processXMLS',
          { xmls: xmlPayload },
          {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${this.token}`
            }
          }
        );
        
        // Extraer los datos de la respuesta
        const respuesta = response.data.respuesta;
        if (respuesta && respuesta.Datos && Array.isArray(respuesta.Datos)) {
          this.resultados = respuesta.Datos.map((item) => {
            // Buscar el archivo correspondiente por consecutivo
            const archivo = this.files.find(f => f.name.replace(/\.xml$/i, '') === item.consecutivo);
            
            return {
              consecutivo: item.consecutivo,
              nameXML: archivo ? archivo.name : `${item.consecutivo}.xml`,
              status: item.status,
              mensaje: item.mensaje,
              procesamiento: item.procesamiento
            };
          });
          
          this.showModal = true;
          this.setAlert('success', `Se procesaron ${this.files.length} archivo(s) XML exitosamente.`);
        } else {
          throw new Error('Estructura de respuesta inesperada');
        }
      } catch (e) {
        this.setAlert('error', 'Error al enviar archivos');
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    setAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.showAlert = true;
      setTimeout(() => (this.showAlert = false), 4000);
    },

    resetAlert() {
      this.alertMessage = '';
      this.alertType = 'success';
      this.showAlert = false;
    },

    getProcessColor(status) {
      switch (status) {
        case 'exitoso':
          return 'green';
        case 'error':
          return 'red';
        case 'pendiente':
          return 'orange';
        default:
          return 'grey';
      }
    },

    getProcessText(status) {
      switch (status) {
        case 'exitoso':
          return 'Exitoso';
        case 'error':
          return 'Error';
        case 'pendiente':
          return 'Pendiente';
        default:
          return 'N/A';
      }
    },

    getDetailedMessage(item) {
      if (!item.procesamiento) {
        return item.mensaje || 'Error desconocido';
      }

      const { recepcion, autorizacion, notificacion } = item.procesamiento;

      const getErrorMessage = (etapa, data) =>
        `Error en ${etapa}: ${data?.mensaje || 'Error desconocido'}`;

      switch (true) {
        case recepcion?.status === 'error':
          return getErrorMessage('recepción', recepcion);

        case autorizacion?.status === 'error':
          return getErrorMessage('autorización', autorizacion);

        case notificacion?.status === 'error':
          return getErrorMessage('notificación', notificacion);

        case recepcion?.status === 'exitoso' &&
            autorizacion?.status === 'exitoso' &&
            notificacion?.status === 'exitoso':
          return 'Documento procesado correctamente';

        case notificacion?.status === 'pendiente':
          return 'Procesamiento completado, notificación pendiente';

        case recepcion?.status === 'exitoso':
          return 'Documento recibido correctamente';

        default:
          return 'Procesamiento en curso';
      }
    },


    async copyClaveAcceso(claveAcceso) {
      try {
        await navigator.clipboard.writeText(claveAcceso);
        this.copyAlert = true;
        setTimeout(() => {
          this.copyAlert = false;
        }, 3000);
      } catch (e) {
        this.setAlert('error', 'No se pudo copiar al portapapeles');
      }
    }
  }
};
</script>

